/* global __webpack_public_path__:writable */
/* exported __webpack_public_path__ */

const domain = new URL((document.currentScript as any).src);
export default __webpack_public_path__ = domain.protocol + "//" + domain.host + "/";
